module.exports = __webpack_public_path__ + "static/media/geren_1.3e5b43af.jpg";